<template>
  <div class="flex flex-wrap items-center justify-center m-auto gap-2 mb-4">
    <div
      :key="book.tenant.id"
      class="rounded-xl shadow-md myMatchesClue w-[580px] sm:w-[320px] border border-gray-500"
    >
      <div class="flex align-top gap-2 pt-4 pr-4 pl-4">
        <div class="sm:w-20 sm:h-20 h-[94px] w-[120px] flex-shrink-0">
          <img
            :src="checkImage(book.tenant.gallery)"
            :alt="book.tenant.name"
            class="w-full m:w-20 sm:h-20 h-[94px] rounded-lg"
          />
        </div>
        <div class="flex flex-col">
          <div class="font-montserrat text-lg">
            {{ capitalizeFirstLetter(book.tenant.name) }}
          </div>
          <div class="font-montserrat text-gray-300 text-sm">
            {{ capitalizeFirstLetter(book.tenant.address) }}
            <span class="whitespace-nowrap" v-if="book.distance"> · {{ book.distance }}</span>
          </div>
        </div>
      </div>
      <div class="w-full !border my-2 rounded-full border-gray-500"></div>
      <div class="flex flex-col gap-3 pb-4 pr-4 pl-4">
        <div class="flex justify-between items-center font-montserrat text-sm font-semibold">
          <div>{{ beautifyShortDate(date, false) }}</div>
          <div v-if="book.bestPriceLocalized">
            <span
              class="mr-2 whitespace-nowrap"
            >{{ capitalizeFirstLetter($t("starting_from")) }}:
            </span>
            <span
              v-html="parsedBestPrice(book.bestPriceLocalized.withoutTaxes, book.bestPriceLocalized.amountStr)"
              class="whitespace-nowrap"
            ></span>
          </div>
        </div>
        <div>
          <CustomSlider
            v-if="book.times && book.times.length > 0"
            :hours="book.times"
            :tenantId="book.tenant.id"
            :tenantName="book.tenant.name"
            :tenantPrivate="book.tenant.private"
            :allowShowMore="allowShowMore"
            @hourSelected="hourSelected"
          />
          <div v-else class="pt-4 pb-2 text-sm text-gray-500">
            {{ $t("search_no_resources_found") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, PropType } from "vue";
import CustomSlider from "@/components/search/customSlider.vue";
import { Format } from "@/helpers/formatHelper";
import { beautifyShortDate, capitalizeFirstLetter } from "@/helpers/dateHelper";

export default defineComponent({
  name: "MatchBookingAvailability",
  emits: ["hourSelected"],
  components: {
    CustomSlider,
  },
  props: {
    book: {
       type: Object as PropType<any>,
      required: true,
    },
    date: {
      type: String,
      required: false,
      default:''
    },
    allowShowMore: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  methods: {
    beautifyShortDate,
    capitalizeFirstLetter,
    checkImage(gallery:any){
      if (gallery != null || gallery != "") {
        let imagesArray = gallery!.split(" ");
        if (imagesArray.length > 0) {
          return imagesArray[0];
        }
      }
      return "@/assets/images/other-image.png"
    },
    parsedBestPrice(showTax: boolean, bestPrice: string){
      if(showTax){
        return Format.addTaxString(bestPrice!);
      }
      return bestPrice;
    },
    hourSelected(hour: any, tenantId:string, tenantName:string, tenantPrivate:boolean) {
      this.$emit("hourSelected", {
        tenantId: tenantId,
        hour: hour,
        name: tenantName,
        private: tenantPrivate,
        defaultLevelProviders: this.book.tenant.defaultLevelProviders
      });
    },
  },
});
</script>

<style scoped>
.myMatchesClue {
    background: var(--background-color);
    height: 210px;
}
</style>
